/**
 * Postprocessing: SELECTIVE bloom + tone mapping. Only materials whose emissive
 * exceeds the luminance threshold (~1) glow — i.e. the gold trim/text — so felt
 * stays matte. MSAA is disabled on the Canvas when this composer is present.
 *
 * CRITICAL — <ToneMapping> MUST be present (and last). The EffectComposer disables
 * the WebGLRenderer's own tone mapping during its render pass, so WITHOUT a
 * ToneMapping effect the scene renders un-tone-mapped (washed-out / pale) — and
 * inconsistently, depending on whether the composer or a direct render frame wins
 * on a given load (the cause of the "first load dark, reload pale" bug). The
 * ACES_FILMIC ToneMapping effect (its default mode) applies tone mapping
 * deterministically every frame and honors the renderer's `toneMappingExposure`
 * (0.62, set on the Canvas `gl` prop in App.tsx).
 */

import { EffectComposer, Bloom, ToneMapping, SMAA } from '@react-three/postprocessing';
import { bloom } from '../theme/tokens';

export function Effects() {
  return (
    <EffectComposer>
      {/* SMAA: cheap edge antialiasing. MSAA is off (postprocessing is on), so the
          thin gold trim + the table/rim curves would otherwise alias/jitter. SMAA
          is a single shader pass — far cheaper than MSAA — and runs first so Bloom
          samples the antialiased image. */}
      <SMAA />
      <Bloom
        luminanceThreshold={bloom.luminanceThreshold}
        luminanceSmoothing={bloom.luminanceSmoothing}
        mipmapBlur={bloom.mipmapBlur}
        intensity={bloom.intensity}
      />
      {/* Final pass — ACES filmic; honors gl.toneMappingExposure (0.62). */}
      <ToneMapping />
    </EffectComposer>
  );
}
